<template>
  <div>
    <card>
      <div class="card-header-custom">
        <button type="submit" class="btn btn-fill btn-primary" @click="$router.push('/users/create')">
          <i class="fa fa-plus"></i> Hinzufügen
        </button>

        <button class="btn btn-success" @click="$router.push('/users/restore')">
            <i class="fa fa-recycle"></i>
            Gelöschte Benutzer
          </button>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Name</th>
                <th>Letzter Login am</th>
                <th>Email</th>
                <th>Telefonnummer</th>
                <th v-if="warehouses.length > 1">Standardlager</th>
                <th>Rolle</th>
                <th>Standort</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in users" :key="user.id">
                <td v-text="user.name"></td>
                <td>
                  <span v-if="user.last_login_at">{{ user.last_login_at | datetime }}</span>
                  <span v-else><a href="#" @click.prevent="resendInvite(user)">Einladung erneut versenden</a></span>
                </td>
                <td v-text="user.email"></td>
                <td v-text="user.phone"></td>
                <td v-if="warehouses.length > 1" v-text="user.warehouse ? user.warehouse.short_name : ''"></td>
                <td v-text="user.role"></td>
                <td>{{ getLocations(user) }}</td>
                <!-- <td v-else></td> -->
                <td class="text-right">
                  <div class="td-actions">
                    <a v-tooltip.top-center="'Bearbeiten'" class="btn btn-warning btn-link btn-xs"
                      @click="editUser(user)">
                      <i class="fa fa-edit"></i>
                    </a>
                    <a v-tooltip.top-center="'Löschen'" class="btn btn-danger btn-link btn-xs" @click="deleteUser(user)">
                      <i class="fa fa-close"></i>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      users: [],
      warehouses: [],
      locations: []
    }
  },
  methods: {
    editUser(user) {
      this.$router.push(`/users/${user.id}/edit`)
    },
    getLocations(user) {
      const locationIds = JSON.parse(user.location_ids)
      if (locationIds) {
        const locations = this.locations.filter(location => locationIds.includes(location.id));
        const locationNames = locations.map(location => location.name);
        return locationNames.join(', ');
      } else {
        return ''; // Return an empty string if locationIds is not defined or empty.
      }
    },
    async deleteUser(user) {
      if (confirm(`User ${user.name} wirklich löschen?`)) {
        await this.initCsrf()

        this.$http.delete(`/users/${user.id}`).then(({ data }) => {
          this.$notify({
            message: `User ${data.name} erfolgreich gelöscht.`,
            type: 'success'
          })
          const index = this.users.findIndex(({ id }) => data.id === id)
          this.users.splice(index, 1)
        })
      }
    },
    async resendInvite(user) {
      await this.initCsrf()

      this.$http.post(`/users/${user.id}/invite`).then(({ data }) => {
        this.$notify({
          message: 'Einladung zur Accountaktivierung wurde versandt.',
          type: 'success'
        })
      })
    }
  },
  created() {
    this.$http.get('/users').then(({ data }) => { this.users = data })
    this.$http.get('/locations').then(({ data }) => { this.locations = data })
    this.$http.get(`/warehouses`).then(({ data }) => { this.warehouses = data })
  }
}
</script>
